__turbopack_context__.v({
  "arrowButton": "CaseStudyHighlight-module__oKvnxa__arrowButton",
  "asideColumn": "CaseStudyHighlight-module__oKvnxa__asideColumn",
  "caseVisual": "CaseStudyHighlight-module__oKvnxa__caseVisual",
  "controls": "CaseStudyHighlight-module__oKvnxa__controls",
  "cta": "CaseStudyHighlight-module__oKvnxa__cta",
  "dot": "CaseStudyHighlight-module__oKvnxa__dot",
  "dotActive": "CaseStudyHighlight-module__oKvnxa__dotActive",
  "dots": "CaseStudyHighlight-module__oKvnxa__dots",
  "factCard": "CaseStudyHighlight-module__oKvnxa__factCard",
  "factGrid": "CaseStudyHighlight-module__oKvnxa__factGrid",
  "factLabel": "CaseStudyHighlight-module__oKvnxa__factLabel",
  "factValue": "CaseStudyHighlight-module__oKvnxa__factValue",
  "kicker": "CaseStudyHighlight-module__oKvnxa__kicker",
  "panel": "CaseStudyHighlight-module__oKvnxa__panel",
  "paragraph": "CaseStudyHighlight-module__oKvnxa__paragraph",
  "quote": "CaseStudyHighlight-module__oKvnxa__quote",
  "quoteAuthor": "CaseStudyHighlight-module__oKvnxa__quoteAuthor",
  "ring": "CaseStudyHighlight-module__oKvnxa__ring",
  "section": "CaseStudyHighlight-module__oKvnxa__section",
  "slide": "CaseStudyHighlight-module__oKvnxa__slide",
  "slide-fade-in": "CaseStudyHighlight-module__oKvnxa__slide-fade-in",
  "textColumn": "CaseStudyHighlight-module__oKvnxa__textColumn",
  "title": "CaseStudyHighlight-module__oKvnxa__title",
});
